module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "content_title"
  }, [_vm._v(_vm._s(_vm.cmsDetailData.title))]), _vm._v(" "), _c('div', {
    staticClass: "content_date"
  }, [_vm._v("\n    发布日期：" + _vm._s(_vm._f("timeFormat")(_vm.cmsDetailData.create_time)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content_container html-data",
    domProps: {
      "innerHTML": _vm._s(_vm.cmsDetailData.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7078814e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/CmsSinglePage.vue
// module id = 1277
// module chunks = 0